export default __webpack_public_path__ + "static/media/pollution.01273575.gif";